module.exports = __webpack_public_path__ + "static/media/cappellini.3ab69248.svg";